module.exports = __webpack_public_path__ + "img/icon-speed-3-old.e01d68de.svg";